<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }

  <h2>Biz Dev Dashboard</h2>

  @if (showSearchUI) {
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=false [showDevelopments]=false
      [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=false [showSeasons]=false
      [showReservationStatuses]=false [showStartDate]=true [showEndDate]=true [showSaleDateStart]=false
      [showSaleDateEnd]=false [showListingStatus]=true [defaultStartDate]="defaultStartDate" [showSaleYear]=false
      [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
      [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCB)="onSearchSubmit($event)">
    </app-search-template>
  }
  <br><br>

  <div class="d-flex justify-content-start align-items-start">
    <div class="row m-0 mb-4 report-statistics">
      <div class="col-12">
        <div class="statistics bg-1 px-5">
          <p>Active Properties:</p>
          <h1>{{bizDevAPI.activeProperties}}</h1>
        </div>
      </div>
    </div>
  </div>
  <!-- <h3>Active Properties: {{bizDevAPI.activeProperties}}</h3> -->
  <br><br>
  <app-biz-dev-property-location [propertyDevelopments]="propertyDevelopments"></app-biz-dev-property-location>
  <app-biz-dev-property-development [propertyDevelopments]="propertyDevelopments"></app-biz-dev-property-development>
  <app-biz-dev-property-bedroom [propertyDevelopments]="propertyDevelopments"></app-biz-dev-property-bedroom>
</div>